export const FALLBACK_SEO = {
    title: "Qualitia | Website",
    description: "Qualitia | Website",
}

export const TIME_ZONES = [
    "(UTC +0) British Isles",
    "(UTC +0) West Africa",
    "(UTC -1) Cabo Verde",
    "(UTC -1) Ponta Delgada (Portugal) and Ittoqqortoormiit (Greenland)",
    "(UTC -1) Ittoqqortoormiit (Greenland)",
    "(UTC -2) Sandwich Island (South Georgia)",
    "(UTC -3) South America and Greenland",
    "(UTC -3) Greenland",
    "(UTC -3:30) Newfoundland and Labrador (Canada)",
    "(UTC -4) South America and Eastern Canada",
    "(UTC -5) South America",
    "(UTC -5) Eastern Canada and Eastern USA",
    "(UTC -5) Eastern USA",
    "(UTC -6) Central America",
    "(UTC -6) Central Canada and Central US",
    "(UTC -7) Western Mexico, Central Canada and Central US",
    "(UTC -8) Western Canada and Western US",
    "(UTC -8) Western US",
    "(UTC -9) Alaska (US)",
    "(UTC -10) French Polynesia, Kiribati",
    "(UTC -10) Cook Islands, Hawaii (US)",
    "(UTC -10) Hawaii (US)",
    "(UTC -11) US Minor Outlying Islands and Niue",
    "(UTC -12) Pacific Islands",
    "(UTC +1) Western and Central Europe",
    "(UTC +1) Africa",
    "(UTC +2) Eastern Europe",
    "(UTC +2) Southern Africa",
    "(UTC +3) Western Russia and Middle East",
    "(UTC +3:30) Iran",
    "(UTC +4) Caucasus and Western Gulf",
    "(UTC +4:30) Afghanistan",
    "(UTC +5) Central Asia, Pakistan",
    "(UTC +5) Russia",
    "(UTC +5:30) India and Sri Lanka",
    "(UTC +5:45) Nepal",
    "(UTC +6) Bangladesh, Bhutan",
    "(UTC +6) Bhutan, and part of Russia",
    "(UTC +6:30) Myanmar",
    "(UTC +6:30) Cocos (Keeling) Islands",
    "(UTC +7) Eastern Asia",
    "(UTC +8) Western Australia",
    "(UTC +8:45) Australia (Eucla)",
    "(UTC +9) Russia and Eastern Asia",
    "(UTC +9:30) Australia",
    "(UTC +9:30) Marquesas Islands",
    "(UTC +10) Russia, Papua New-Guinea and Eastern Australia",
    "(UTC +10) Eastern Australia",
    "(UTC +10) New-Guinea and Eastern Australia",
    "(UTC +10:30) Australia (South and Broken Hill)",
    "(UTC +10:30/+11) Lord Howe Island",
    "(UTC +11) Oceania Islands",
    "(UTC +12) Russia and Oceania Islands",
    "(UTC +12:45/+13:45) (New Zealand)",
    "(UTC +13) Pacific Islands"
  ];
  
  export const HOURS_ARRAY = [
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
  ];